import { Pagination as AntdPagination } from 'antd';
import classNames from 'classnames';
import * as React from 'react';
import { pickDomAttrs } from '../_util/utils';
import { useConfig } from '../hooks/useConfig';
import { getTransedText } from '../locale';
import Select from '../select';
import { jsx as _jsx } from "react/jsx-runtime";
export const DEFAULT_pageNum = 1;
export const DEFAULT_pageSize = 20;
export const DEFAULT_pageSizeOptions = ['10', '20', '50', '100'];
const SelectComponent = props => /*#__PURE__*/_jsx(Select, {
  ...props,
  showSearch: false,
  size: "s",
  className: undefined
});
SelectComponent.Option = Select.Option;
const Pagination = props => {
  const {
    pageNum = 1,
    pageSize = DEFAULT_pageSize,
    total = 0,
    onChange,
    showTotal,
    simple,
    showSizeChanger = true,
    pageSizeOptions = DEFAULT_pageSizeOptions,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const {
    locale: {
      Pagination: PaginationLocale
    }
  } = useConfig();
  const baseClassName = "".concat(prefixClass, "-pagination");
  const attrs = pickDomAttrs(restProps);
  const _showTotal = total => {
    if (showTotal) {
      return showTotal(total);
    }
    if (showTotal === false) {
      return '';
    }
    return total === 1 ? PaginationLocale.oneTotalText : getTransedText(PaginationLocale.moreTotalText, {
      totalCount: total
    });
  };
  return /*#__PURE__*/_jsx(AntdPagination, {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    showSizeChanger: showSizeChanger,
    pageSizeOptions: pageSizeOptions,
    current: pageNum,
    pageSize: pageSize,
    total: total,
    showTotal: _showTotal,
    simple: simple,
    onChange: onChange,
    locale: PaginationLocale,
    selectComponentClass: SelectComponent
  });
};
export default Pagination;